import {axios} from './api';

export default class IllustratorBorrowerServiceApi {
  static baseUrl = '/linkRequests';

  static async save(data, config) {
    return axios.post(`${this.baseUrl}`, data, config);
  }
}
